import { apiClient } from '../api/client';
import { url as apiUrl } from '../api';
import { toast } from 'react-toastify';




// it will return a URL object or null
const fetchIcon = async (code: string) => {
    const cacheKey = `icon-cache-${code}`;

    // 1. try to get from localStorage cache first
    const cachedDataUrl = localStorage.getItem(cacheKey);
    if (cachedDataUrl) {
        return cachedDataUrl;
    }

    try {
        // 2. fetch from backend
        const axiosConfig = { responseType: 'blob' as const };
        const response = await apiClient.get(
            `${apiUrl}/api/icons/icon/${code}`,
            axiosConfig
        );
        const blob = new Blob([response.data], {
            type: response.headers['content-type'],
        });

        // convert blob to base64 data url for persistent caching
        const dataUrl: string = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result as string);
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(blob);
        });

        // 3. save to localStorage (best-effort)
        try {
            localStorage.setItem(cacheKey, dataUrl);
        } catch (e) {
            // silently ignore quota errors – still return the freshly fetched icon
            console.warn('icon cache quota exceeded, skipping localStorage save');
        }

        return dataUrl;
    } catch (error) {
        console.error('Error fetching icon:', error);
        toast.error('Failed to fetch icon');
        return null;
    }
}

const uploadIcon = async (icon: File) => {
    try {
        const headers = { headers: { 'Content-Type': 'multipart/form-data' } };
        const formData = new FormData();
        formData.append('icon', icon);

        const response = await apiClient.post(
            `${apiUrl}/api/icons/upload`,
            formData,
            headers
        );

        return response.data;
    } catch (error) {
        console.error('Error uploading icon:', error); // updated error message
        toast.error('Failed to upload icon'); // updated toast message
    }
}

const listIcons = async () => {
    try {
        const headers = {};
        const response = await apiClient.get(
            `${apiUrl}/api/icons/list`,
            headers
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching badge image:', error);
        toast.error('Failed to fetch badge image');
    }
}

const deleteIcon = async (code: string) => {
    try {
        const headers = {};
        await apiClient.delete(
            `${apiUrl}/api/icons/icon/${code}`,
            headers
        );
        return;
    } catch (error) {
        console.error('Error deleting icon:', error);
        toast.error('Failed to delete icon');
    }
}

export { fetchIcon, uploadIcon, listIcons, deleteIcon };
